// @flow

import _ from 'lodash';
import gql from 'graphql-tag';

import { graphql } from '@apollo/react-hoc';

import SplitLoginPage from 'app/login/components/SplitLoginPage';
import maybeRender from 'app/common/components/maybeRender';
import serviceInfo from 'app/graphql/fragments/service/serviceInfo';
import { enableSentryRequestLogging } from 'app/common/middlewares/sentryErrorsMiddleware';

type OwnProps = {
  selectedApis: Array<string>,
};

/* eslint-disable graphql/no-deprecated-fields */
// FIXME: Get rid of deprecated `Query.service` field. Being tracked here:
// https://zapierorg.atlassian.net/browse/FLX-1773
const twoServiceQuery = gql`
  query twoServiceQuery($headService: String!, $tailService: String!) {
    headService: service(id: $headService) {
      ...serviceInfo
    }
    tailService: service(id: $tailService) {
      ...serviceInfo
    }
  }

  ${serviceInfo}
`;
/* eslint-enable graphql/no-deprecated-fields */

export default _.flowRight(
  graphql(twoServiceQuery, {
    options: (props: OwnProps) => {
      const [s1, s2] = props.selectedApis;

      return {
        variables: enableSentryRequestLogging({
          headService: s1,
          tailService: s2,
        }),
      };
    },
  }),
  maybeRender(props => !props.data.loading)
)(SplitLoginPage);
